export default {
    filters: {
      technologyFilter: '',
      startupPhaseFilter: '',
      universityFilter: '',
      countryBPFilter: '',
      cantonFilter: '',
      legalformFilter: '',
      caseStatusFilter: '',
      roles: '',
      vekmisTechnology: '',
      prioVlabType: '',
      prioXmasType: '',
      eventTitles: '',
      eventPoolThemes: '',
      cityBP: '',
      zipBP: '',
      salutation: '',
      unispinoff: '',
      awards: '',
      sectors: '',
      incorporationDate: '',
      totalFunding: '',
      reportingGroups: '',
      eventSortDate: '',
      addressInterests: '',
      interestsByStatus: '',
      affirmation: '',
      combinedEventTitleAffirmation: '',
      combinedThemeAffirmation: ''
    },
    eventTitles: [],
    eventPoolThemes: [],
    interestsStatus: []
  }
